module.exports = __webpack_public_path__ + "img/ld.9065ab84.png";